import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export const MapResizer = ({ mapRef, visible }) => {
  const map = useMap();

  useEffect(() => {
    if (mapRef) mapRef.current = map;
  }, [map, mapRef]);

  useEffect(() => {
    if (visible && map) {
      setTimeout(() => map.invalidateSize(), 100);
    }
  }, [visible, map]);

  return null;
};
